//Redux Toolkit
import { createSelector } from "@reduxjs/toolkit";

//Settings
import { _resultsPerPage } from "../../../constants/paginaton-settings";

//Selectors
import { selectFacetedResults } from "../facets/select-faceted-results";
import { selectCurrentUnmatchedPage } from "./select-current-unmatched-page";

/** Returns all of the non matched results up to the current page.  The nearby community
 * list that uses this has a load more link so there will only even be one page that size
 * keeps getting bigger as the user clicks the load more link.
 */
export const selectPageOfUnmatchedResults = createSelector(
	[selectFacetedResults, selectCurrentUnmatchedPage],
	(results, currentPage) => {
		return results?.UnmatchedResults?.slice(0, currentPage * _resultsPerPage);
	},
);
